import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useI18n } from 'contexts/i18n'
import { useDocuments } from 'contexts/documents'
import { useTimeout } from 'hooks/timeout'
import { cls } from 'utilities/dom'
import { safeFormat, isofy } from 'utilities/date-time'
import { differenceInMilliseconds, addMinutes } from 'date-fns'
import { CaptionSmall } from 'components/typography/caption'
import Link from 'components/link'

const minutesBetweenReminders = 5

const SigningStatusRemind = ({ dokument }) => {
    const { dateLocale: locale } = useI18n()

    const { remindSigners } = useDocuments()

    const { lastRemindedAt } = dokument.signing

    const [now] = useState(new Date())
    const [reminding, setReminding] = useState(false)
    const [reminded, setReminded] = useState(lastRemindedAt ?
        differenceInMilliseconds(now, isofy(lastRemindedAt)) < (minutesBetweenReminders * 60 * 1000) :
        false
    )

    useTimeout(() => {
        setReminded(false)
    }, differenceInMilliseconds(addMinutes(isofy(lastRemindedAt), minutesBetweenReminders), now))

    const remind = async () => {
        setReminding(true)
        const { ok } = remindSigners(dokument.id)
        setReminding(false)

        ok && setReminded(true)
    }

    return (
        <>
            {!!reminded && (
                <CaptionSmall className="compact">
                    <FormattedMessage
                        id="document_signing_label_last_reminded_at"
                        defaultMessage="Last reminded at {date}"
                        values={{ time: safeFormat(lastRemindedAt, 'p', { locale }) }} />
                </CaptionSmall>
            )}
            {!reminded && (
                <Link
                    onClick={remind}
                    className={cls([
                        'constructive',
                        reminding && 'loading'
                    ])}>
                    <FormattedMessage
                        id="document_signing_action_send_reminder"
                        defaultMessage="Send reminder" />
                </Link>
            )}
        </>
    )
}

export default SigningStatusRemind